import * as Sentry from '@sentry/react';
import {
  OFFICE_EXTENSIONS,
  officeEmbedUrl,
} from '@/pages/workflow/component/display-components';
import { refreshFileUrls } from '@/services/workflow/get-file';
import { openExternalUrl } from '@/utils/url-utils';
import type { ArtifactListItem } from '@/types/artifacts';
import type { NodeFile } from '@/types/node-types';

function getPrimaryFile(artifact: ArtifactListItem): NodeFile | null {
  if (!artifact.primary_file_s3_bucket || !artifact.primary_file_s3_key) {
    return null;
  }
  return {
    name: artifact.primary_file_name ?? artifact.title,
    mime_type: artifact.primary_file_mime_type ?? 'application/octet-stream',
    s3_bucket: artifact.primary_file_s3_bucket,
    s3_key: artifact.primary_file_s3_key,
    s3_region: artifact.primary_file_s3_region ?? '',
    generated: artifact.primary_file_generated ?? true,
    presigned_url: artifact.primary_presigned_url ?? '',
    download_url: artifact.primary_download_url,
    proxy_url: artifact.primary_proxy_url,
  };
}

function openFile(file: NodeFile) {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (OFFICE_EXTENSIONS.includes(ext)) {
    const previewUrl = file.proxy_url || file.presigned_url;
    if (previewUrl) {
      openExternalUrl(officeEmbedUrl(previewUrl));
    }
  } else if (file.presigned_url) {
    openExternalUrl(file.presigned_url);
  }
}

export async function openArtifact(
  orgId: string,
  artifact: ArtifactListItem,
): Promise<void> {
  const file = getPrimaryFile(artifact);
  if (!file || !file.s3_bucket || !file.s3_key) return;
  try {
    const [refreshed] = await refreshFileUrls(orgId, [file]);
    openFile(refreshed ?? file);
  } catch (err) {
    Sentry.captureException(err, {
      extra: {
        context: 'open-artifact-refresh',
        orgId,
        artifactId: artifact.id,
      },
    });
    openFile(file);
  }
}
